<template>
  <div>
    <InvoiceSettingsUser
      v-if="scope === 'user'"
      :invoice="invoice"
      @reinit="handleReinit"
    />
    <InvoiceSettingsConcierge
      v-else-if="scope === 'setting'"
      :invoice="invoice"
      @reinit="handleReinit"
    />
    <div v-else></div>
  </div>
</template>

<script>
import InvoiceSettingsConcierge from "@/components/invoice/InvoiceSettingsConcierge";
import InvoiceSettingsUser from "@/components/invoice/InvoiceSettingsUser";
export default {
  components: {
    InvoiceSettingsConcierge,
    InvoiceSettingsUser
  },
  props: {
    scope: {
      type: String,
      default: null
    },
    invoice: {
      type: [Object],
      default: null
    }
  },
  methods: {
    handleReinit() {
      this.$emit("reinit");
    }
  }
};
</script>

<style></style>
